import actions from './actions';

const {
  GET_OUR_TEAM_BEGIN,
  GET_OUR_TEAM_SUCCESS,
  GET_OUR_TEAM_FAILED,
  ADD_OUR_TEAM_BEGIN,
  ADD_OUR_TEAM_SUCCESS,
  ADD_OUR_TEAM_FAILED,
  UPDATE_OUR_TEAM_BEGIN,
  UPDATE_OUR_TEAM_SUCCESS,
  UPDATE_OUR_TEAM_FAILED,
  DELETE_OUR_TEAM_BEGIN,
  DELETE_OUR_TEAM_SUCCESS,
  DELETE_OUR_TEAM_FAILED,
} = actions;

const initState = {
  ourTeam: [],
  total: 0,
  loading: false,
  currentPage: null,
  pageLimit: null,
  error: null,
};

const OurTeamReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_OUR_TEAM_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_OUR_TEAM_SUCCESS:
      return {
        ...state,
        ourTeam: data.teams,
        total: data.total,
        currentPage: data.currentPage,
        pageLimit: data.pageLimit,
        loading: false,
      };
    case GET_OUR_TEAM_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_OUR_TEAM_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_OUR_TEAM_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        ourTeam: data,
        loading: false,
      };
    case ADD_OUR_TEAM_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_OUR_TEAM_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_OUR_TEAM_SUCCESS:
      return {
        ...state,
        ourTeam: data,
        loading: false,
      };
    case UPDATE_OUR_TEAM_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_OUR_TEAM_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_OUR_TEAM_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        ourTeam: data,
        loading: false,
      };
    case DELETE_OUR_TEAM_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default OurTeamReducer;
